<template>
  <!-- 积分查询 -->
  <div class="pointsInquiry">
    <van-nav-bar :title="'我的积分'"
                 left-text
                 left-arrow
                 @click-left="onClickLeft"
                 :fixed="true">
      <template #right>
        <van-tag round
                 type="primary"
                 @click="checkYear">{{year}}</van-tag>
      </template>
    </van-nav-bar>
    <div class="content">
      <div class="points_top">
        <div class="point_num">
          <div class="num1">
            <div class="fk1">{{baseinfo.total_credit?baseinfo.total_credit:0}}</div>
            <div class="un1">累计积分</div>
          </div>
          <div class="num2">
            <div class="fk2">{{baseinfo.balance_credit?baseinfo.balance_credit:0}}</div>
            <div class="un2">剩余积分</div>
          </div>
        </div>
        <div class="txt">
          <!-- <div class="used">
            <div class="un1">总积分</div>
            <div class="un2">剩余积分</div>
          </div> -->
          <!-- <div class="empname">{{baseinfo.empcode}}</div> -->
          <div class="empname">{{baseinfo.empname}}</div>
          <div class="check"
               @click="checkPointsRanking">积分排名</div>
        </div>
      </div>
      <div class="details">积分明细</div>
      <div class="points_list">
        <van-cell-group>
          <van-cell v-for="(item,idx) in pointList"
                    :key="idx">
            <template #title>
              <div class="cell_title">{{item.at_subject}}</div>
              <div class="time">{{item.crdate}}</div>
            </template>
            <template #default>
              <div class="cell_val"
                   :class="item.credit>0?'zheng':'fu'">{{(item.credit>0?'+':'')+item.credit}}</div>
              <!-- <div class="result">623</div> -->
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <van-popup v-model="showYearPicker"
                 round
                 position="bottom">
        <van-picker title="选择年份"
                    show-toolbar
                    :default-index="100"
                    :columns="yyyyColumns"
                    @confirm="onConfirm"
                    @cancel="showYearPicker = false" />
      </van-popup>
    </div>

  </div>
</template>

<script>
import { getEmpCreditInfo } from '@api/integral.js'
export default {
  data () {
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    return {
      userInfo,
      showYearPicker: false,
      year: '',
      baseinfo: {},
      pointList: []
    }
  },
  computed: {
    yyyyColumns () {
      let yyyys = []
      let currentYear = new Date().getFullYear();
      for (let i = 0; i < 60; i++)
      {
        const el = currentYear - i
        yyyys.push(el)
      }
      for (let i = 1; i <= 100; i++)
      {
        const el = currentYear + i
        yyyys.unshift(el)
      }
      return yyyys
    }
  },
  created () {
    this.year = new Date().getFullYear()
    this.getEmpCreditInfoData(this.year)
  },
  methods: {
    onConfirm (value) {
      this.year = value;
      this.showYearPicker = false;
      this.getEmpCreditInfoData(this.year)
    },
    // 获取员工指定年度的积分信息
    getEmpCreditInfoData (yyyy) {
      getEmpCreditInfo({
        yyyy: yyyy,
        username: this.userInfo.username
      }).then(res => {
        this.baseinfo = res.baseinfo.length > 0 ? res.baseinfo[0] : {}
        this.pointList = res.data
      })

    },
    checkYear () {
      this.showYearPicker = true;
    },
    // 查看积分排名
    checkPointsRanking () {
      this.$router.push({
        path: '/pointsRanking',
        query: { topdeptname: this.baseinfo.topdeptname, year: this.year, from: this.$route.query.from }
      })
    },
    // 返回
    onClickLeft () {
      if (this.$route.query.from == 'home')
      {
        this.$router.push('/home')
      } else
      {
        this.$router.push('/personCen')
      }
    },
  }

}
</script>

<style lang="less" scoped>
.pointsInquiry {
  height: 100vh;
  overflow: hidden;
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
    .van-nav-bar__right {
      .van-tag {
        background-color: #f6f6f6;
        color: #333333;
        padding: 6px 20px;
        font-size: 28px;
      }
    }
  }
  .van-nav-bar::after {
    border: none !important;
  }
  .content {
    // overflow: auto;
    margin-top: 1.21667rem;
    height: calc(100% - 92px);
    .points_top {
      // height: 164px;
      height: 196px;
      background-image: linear-gradient(to bottom, #2b8df0, #1282f4);
      .point_num {
        padding: 0 20px;
        text-align: center;
        color: #ffffff;
        font-size: 60px;
        font-weight: bold;
        display: flex;
        justify-content: center;
        .num1 {
          width: 50%;
          margin-right: 10px;
          display: flex;
          flex-direction: column;
          align-items: center;
          line-height: 1.2;
          justify-content: center;
          .un1 {
            font-size: 30px;
            color: #cccccc;
            font-weight: normal;
          }
        }
        .num2 {
          width: 50%;
          margin-left: 10px;
          display: flex;
          flex-direction: column;
          align-items: center;
          line-height: 1.2;
          justify-content: center;
          .un2 {
            font-size: 30px;
            color: #cccccc;
            font-weight: normal;
          }
        }
      }
      .txt {
        padding: 10px 20px;
        margin-top: 20px;
        position: relative;
        font-size: 30px;
        text-align: center;
        display: flex;
        justify-content: space-between;
        .used {
          display: flex;
          justify-content: center;
          color: #cccccc;
          .un1 {
            width: 50%;
            margin-right: 10px;
            text-align: right;
          }
          .un2 {
            width: 50%;
            margin-left: 10px;
            text-align: left;
          }
        }
        .check {
          color: #ffffff;
          // position: absolute;
          bottom: 10px;
          right: 20px;
        }
        .empname {
          color: #ffffff;
          // position: absolute;
          bottom: 10px;
          left: 20px;
        }
      }
    }
    .details {
      height: 70px;
      padding: 10px 20px;
      font-size: 30px;
      color: #cccccc;
    }
    .points_list {
      height: calc(100% - 266px);
      overflow-y: auto;
      .van-cell-group {
        .van-cell {
          padding: 20px 20px;
          font-size: 30px;
          .van-cell__title {
            flex: 3;
            .cell_title {
              font-size: 32px;
              color: #000000;
            }
            .time {
              font-size: 28px;
              color: #8e8e8e;
            }
          }
          .van-cell__value {
            .cell_val {
              font-size: 32px;
            }
            .zheng {
              color: #07c160;
            }
            .fu {
              color: #ff976a;
            }
            .result {
              font-size: 28px;
              color: #8e8e8e;
            }
          }
        }
      }
    }
  }
}
</style>